import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {FileUploadService} from '../../../services/file-upload.service';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {SendedFile} from '../../../model/SenderFile';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {OctetPipe} from "../OctetPipe";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";


@Component({
    selector: 'app-upload-file',
    templateUrl: './upload-file.component.html',
    imports: [
    FaIconComponent,
    OctetPipe,
    NgbTooltip
],
    styleUrls: ['./upload-file.component.css']
})
export class UploadFileComponent {

  @Input() mobile = false;
  @Input() sendedFiles: SendedFile[] = [];
  @Output() sendedFilesChange = new EventEmitter<SendedFile[]>();

  @ViewChild('fileinput') fileinput: ElementRef;

  sizelimit = 10485760;

  private sendingFiles: File[] = [];

  constructor(private fileUpload: FileUploadService) {
  }

  uploadFile(event): void {
    const files = (event.target as HTMLInputElement).files;
    this.sendingFiles = this.sendingFiles.concat(Array.from(files));
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < files.length; i++) {
      this.sendedFiles.push({
        progress: 0,
        filename: files[i].name,
        size: files[i].size,
        uploaded: false,
        toolarge: false,
        sub: undefined,
        id: undefined
      });
      this.sendedFilesChange.emit(this.sendedFiles);
    }
    this.startNextUpload();
  }

  launchUpload(file: File): void {
    const obj = this.sendedFiles.find(sf => sf.filename === file.name && sf.size === file.size);
    if (file.size > this.sizelimit) {
      obj.toolarge = true;
      obj.uploaded = true;
      this.sendingFiles = this.sendingFiles.filter(f => !(obj.filename === f.name && obj.size === f.size));
      this.startNextUpload();
    } else {
      obj.sub = this.fileUpload.uploadFile(file).subscribe((e: HttpEvent<any>) => {
        switch (e.type) {
          case HttpEventType.UploadProgress:
            obj.progress = Math.round(e.loaded / e.total * 100);
            break;
          case HttpEventType.Response:
            obj.id = e.body.fileId;
            obj.uploaded = true;
            obj.progress = 0;

            this.sendingFiles = this.sendingFiles.filter(f => !(obj.filename === f.name && obj.size === f.size));
            this.startNextUpload();
        }
      });
    }
    this.sendedFilesChange.emit(this.sendedFiles);
  }

  startNextUpload(): void {
    const next = this.sendedFiles.find(sf => !sf.uploaded);
    if (next !== undefined) {
      const file = this.sendingFiles.find(f => next.filename === f.name && next.size === f.size);
      if (file !== undefined) {
        this.launchUpload(file);
      }
    } else {
      this.fileinput.nativeElement.value = null;
    }
  }

  cancelUpload(file: SendedFile): void {
    file.sub.unsubscribe();
    this.deleteFile(file);
    this.startNextUpload();
  }

  deleteFile(file: SendedFile): void {
    if (file.id) {
      this.sendedFiles = this.sendedFiles.filter(sf => sf.id !== file.id);
    } else {
      this.sendedFiles = this.sendedFiles.filter(sf => !(sf.filename === file.filename && sf.size === file.size));
    }
    this.sendingFiles = this.sendingFiles.filter(f => !(file.filename === f.name && file.size === f.size));
    this.sendedFilesChange.emit(this.sendedFiles);
    if (this.sendingFiles.length === 0) {
      this.fileinput.nativeElement.value = '';
    }
  }

}
